import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorHandler, HandleError } from '../../../http-error-handler.service';
import { EndpointLocationProviderService } from '../../services/endpoint-location-provider.service';

@Injectable({
    providedIn: 'root'
})
export class PagesFilterService {

    private env = environment;
    private handleError: HandleError;

    constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler, private endpointLocationService: EndpointLocationProviderService) {
        this.handleError = httpErrorHandler.createHandleError('PagesFilterService');
    }

    getListProdutos(idAutoridadeCertificadora: number): Observable<any> {
        return this.http
            .get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_RELATORIOS)}/api/Produto/GetListProdutos/${idAutoridadeCertificadora}`)
            .pipe(
                catchError(this.handleError('Buscar lista de Produtos', []))
            );
    }

    getListTipos(): Observable<any> {
        return this.http
            .get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_RELATORIOS)}/api/Produto/GetListTipos`)
            .pipe(
                catchError(this.handleError('Buscar os tipos de produtos.', []))
            );
    }

    getListModelos(): Observable<any> {
        return this.http
            .get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_RELATORIOS)}/api/Produto/GetListModelos`)
            .pipe(
                catchError(this.handleError('Buscar os modelos de produtos.', []))
            );
    }

    getListValidades(): Observable<any> {
        return this.http
            .get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_RELATORIOS)}/api/Produto/GetListValidades`)
            .pipe(
                catchError(this.handleError('Buscar os validades de produtos.', []))
            );
    }

    getListTipoEmissao(): Observable<any> {
        return this.http
            .get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_RELATORIOS)}/api/Produto/GetListTipoEmissao`)
            .pipe(
                catchError(this.handleError('Buscar o tipo de emissão dos produtos.', []))
            );
    }

    getListTipoIdentificacao(): Observable<any> {
        return this.http
            .get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_RELATORIOS)}/api/TipoIdentificacao/GetList`)
            .pipe(
                catchError(this.handleError('Buscar o tipo de identificação.', []))
            );
    }

    getListStatusACI(): Observable<any> {
        return this.http
            .get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_RELATORIOS)}/api/DossieStatus/GetList/`)
            .pipe(
                catchError(this.handleError('Buscar lista de Status ACI', []))
            );
    }

    getDropdownListAgenteRegistro(idsLocaisDeAtendimento: any[]): Observable<any> {
        return this.http
            .post(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_RELATORIOS)}/api/RelatorioQuantidade/GetAgenteRegistroDropdownList`, JSON.stringify(idsLocaisDeAtendimento))
            .pipe(
                catchError(this.handleError('Buscar lista dropdown de Agentes de Registro', []))
            );
    }

    getParceiros(): Observable<any> {
        return this.http
          .get(`${this.endpointLocationService.getEndpointURI(this.env.API_ENDPOINT_PARCEIRO)}/api/Parceiro/GetAll`)
          .pipe(
            catchError(this.handleError('Buscar Permissão', []))
          );
      }
}
